import { create } from 'zustand';

type ViewMode = 'grid' | 'list';
type SortByType = 'recent' | 'popular' | 'contributors';
type ContentType = 'projects' | 'posts';

interface ExploreState {
    contentType: ContentType;
    sortBy: SortByType;
    viewMode: ViewMode;
    searchQuery: string;
    filters: {
        type: string;
        status: string;
        skills: string;
    };
    setContentType: (contentType: ContentType) => void;
    setSortBy: (sortBy: SortByType) => void;
    setViewMode: (viewMode: ViewMode) => void;
    setSearchQuery: (query: string) => void;
    setFilters: (filters: Partial<ExploreState['filters']>) => void;
}

const useExploreStore = create<ExploreState>((set) => ({
    contentType: 'projects',
    sortBy: 'recent',
    viewMode: 'grid',
    searchQuery: '',
    filters: {
        type: 'all',
        status: 'all',
        skills: ''
    },
    setContentType: (contentType) => set({ contentType }),
    setSortBy: (sortBy) => set({ sortBy }),
    setViewMode: (viewMode) => set({ viewMode }),
    setSearchQuery: (searchQuery) => set({ searchQuery }),
    setFilters: (newFilters) => set((state) => ({ filters: { ...state.filters, ...newFilters } })),
}));

export default useExploreStore; 